import Service from "../Service";
 
const resource = "TltCheckListUser/";

export default {
    pagination(parameters, requestID) {
        console.log("pagination", parameters);
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },
};